function timesheetEditDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/timesheet-edit/timesheet-edit-dialog.html?$$REVISION$$'
  }
}

export { timesheetEditDialog }
